/* eslint-disable react/require-default-props */
import React from 'react';
import { Container } from './styles';

interface AiManagementUpdatesBellProps {
  count?: number;
  className?: string;
  onClick: () => void;
}

const updatesBellLabel = (count: number) =>
  count === 1 ? '1 novidade na licitação' : `${count} novidades na licitação`;

const AiManagementUpdatesBell: React.FC<AiManagementUpdatesBellProps> = ({
  count = 0,
  className = '',
  onClick,
}) => {
  if (!count) return null;

  const label = updatesBellLabel(count);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <Container className={className}>
      <button
        type="button"
        className="updates-bell-button badge badge-danger border-0 d-inline-flex align-items-center"
        aria-label={label}
        onClick={handleClick}
      >
        <i className="material-icons mr-1">notifications</i>
        {count}
      </button>
      <span className="updates-bell-tooltip" role="tooltip">
        {label}
      </span>
    </Container>
  );
};

export default AiManagementUpdatesBell;
